import React from 'react'
import { Container } from '../styles/Container';
import styled from 'styled-components'

const InstagramWidget = ({ data, translations }: any) => {
  
  return (
    <Wrapper>
      <StyledContainer>
        {data?.title && (
          <Content>
            <h2>{data.title}</h2></Content>
        )}
        <Widget>
          <div className={data.widget_class} data-elfsight-app-lazy></div> 
        </Widget>
      </StyledContainer>
    </Wrapper>
  )
}

export default InstagramWidget

const Wrapper = styled.div<any>`
  padding: 3rem 0;
  // background-color: ${(props) => props.backgroundColor === 'light-blue' ? 'var(--lighter-blue)' : 'white'};
  text-align: center;
`

const StyledContainer = styled(Container)`
    margin-top: 0;
    margin-bottom: 0;
`

const Content = styled.div<any>`
  margin-bottom: 2rem;
  text-align: center;
  h2 {
    font-size: 2.25rem;
    margin-top: 0;
    color: var(--text);
    &:last-child {
        margin-bottom: 0;
    }
  }
`

const Widget = styled.div<any>``
